import React from 'react';
import ErrorFallback from './ErrorFallback';
import {Link, useLocation} from 'react-router-dom';
import searchFilter from '../searchFilter';

const ErrorFallbackHomePage = (e) => {
    const location = useLocation();
    return (
        <div>
            <Link to={`/${searchFilter(location.search)}`} className='link padding-bottom-2rem display-block'>Return to main page</Link>
            <ErrorFallback {...e}/>    
        </div>
    )
}

export default ErrorFallbackHomePage;